import { Injectable, signal, WritableSignal } from '@angular/core';

export type NavbarApp = { name: string; link: string };

@Injectable({ providedIn: 'root' })
export class NavbarStateService {
  readonly navCollapse: WritableSignal<boolean> = signal<boolean>(false);

  readonly appName: WritableSignal<NavbarApp> = signal<NavbarApp>({
    name: 'Portail',
    link: '/',
  });

  readonly toggleAppList: WritableSignal<boolean> = signal<boolean>(true);
}
